import React from "react";
import {Box, GlobalStyles, Stack} from "@mui/material";

interface Props {
    actions: React.ReactNode;
    children: React.ReactNode;
    sidebar: React.ReactNode;
}

const SIDEBAR_WIDTH = 454;

// Preview chrome only; the document renderer owns paper geometry and native pagination.
const PrintPreviewPageShell = ({
                                   actions,
                                   children,
                                   sidebar,
                               }: Props) => (
    <>
        <GlobalStyles
            styles={{
                "@media print": {
                    body: {
                        background: "#fff",
                    },
                    ".print-preview-page": {
                        display: "block !important",
                        height: "auto !important",
                        minHeight: "auto !important",
                        overflow: "visible !important",
                    },
                    ".print-preview-sidebar": {
                        display: "none !important",
                    },
                    ".print-preview-main": {
                        background: "#fff !important",
                        display: "block !important",
                        overflow: "visible !important",
                        padding: "0 !important",
                    },
                },
            }}
        />

        <Box
            className="print-preview-page"
            sx={{
                bgcolor: "#eef2f7",
                display: "flex",
                flexDirection: {
                    xs: "column",
                    md: "row",
                },
                height: {
                    xs: "auto",
                    md: "100vh",
                },
                minHeight: "100vh",
                overflow: {
                    xs: "auto",
                    md: "hidden",
                },
            }}
        >
            <Box
                className="print-preview-sidebar"
                sx={{
                    bgcolor: "background.paper",
                    borderRight: 1,
                    borderColor: "divider",
                    display: "flex",
                    flexDirection: "column",
                    flexShrink: 0,
                    height: {
                        xs: "auto",
                        md: "100vh",
                    },
                    order: {
                        xs: 2,
                        md: 1,
                    },
                    position: {
                        xs: "static",
                        md: "sticky",
                    },
                    top: 0,
                    width: {
                        xs: "100%",
                        md: SIDEBAR_WIDTH,
                    },
                    borderRightWidth: {
                        xs: 0,
                        md: 1,
                    },
                    borderTop: {
                        xs: 1,
                        md: 0,
                    },
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        flex: {
                            xs: "none",
                            md: 1,
                        },
                        minHeight: 0,
                        overflowY: {
                            xs: "visible",
                            md: "auto",
                        },
                        p: {
                            xs: 2,
                            sm: 3,
                        },
                    }}
                >
                    {sidebar}
                </Box>

                <Stack
                    direction="row"
                    spacing={1}
                    sx={{
                        borderTop: 1,
                        borderColor: "divider",
                        flexShrink: 0,
                        p: {
                            xs: 2,
                            sm: 3,
                        },
                    }}
                >
                    {actions}
                </Stack>
            </Box>

            <Box
                className="print-preview-main"
                sx={{
                    boxSizing: "border-box",
                    display: "block",
                    flex: 1,
                    minWidth: 0,
                    order: {
                        xs: 1,
                        md: 2,
                    },
                    overflow: {
                        xs: "visible",
                        md: "auto",
                    },
                    p: {
                        xs: 2,
                        sm: 3,
                        md: 4,
                    },
                    width: {
                        xs: "100%",
                        md: "auto",
                    },
                }}
            >
                {children}
            </Box>
        </Box>
    </>
);

export default PrintPreviewPageShell;
